import { render, staticRenderFns } from "./modalLoyalty.vue?vue&type=template&id=2305cdca"
import script from "./modalLoyalty.vue?vue&type=script&lang=js"
export * from "./modalLoyalty.vue?vue&type=script&lang=js"
import style0 from "./modalLoyalty.vue?vue&type=style&index=0&id=2305cdca&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports